import bootstrapCSS from '!!raw-loader!bootstrap/dist/css/bootstrap.min.css';
import fontawesomeCSS from '!!raw-loader!@awesome.me/kit-bd5fe14630/icons/css/svg-with-js.min.css';
import sharedCSS from '!!raw-loader!../shared/shared.css';

export const bootstrapStyle = `${bootstrapCSS}\n${fontawesomeCSS}\n${sharedCSS}`; // Exporting just the CSS content